import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import AddCMSPageNew from "../../components/CMS/AddCMSPageNew";



const AddCMSPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb  id="title" title2="CMS" link2="/cms" title="Add CMS" />

        {/* AddUserLayer */}
        <AddCMSPageNew />


      </MasterLayout>
    </>
  );
};

export default AddCMSPage;
